<template>
  <div class="md-layout text-center">
    <div class="login-content md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card header-color="green" :loginConfig="loginConfig">
        <h4 slot="title" class="title" style="font-size: 18px;font-weight: initial;">登录</h4>
        <md-button slot="buttons" class="md-just-icon md-simple md-white" style="margin-right: 30px !important;">
          <md-icon md-src="/static/svg/login/cmmi.svg"></md-icon>
        </md-button>
        <md-button slot="buttons" class="md-just-icon md-simple md-white" style="margin-right: 30px !important;">
          <md-icon md-src="/static/svg/login/iso.svg"></md-icon>
        </md-button>
        <md-button slot="buttons" class="md-just-icon md-simple md-white">
          <md-icon md-src="/static/svg/login/ccc.svg"></md-icon>
        </md-button>
        <p slot="description" class="description">{{loginConfig.systemName}}</p>
        <md-field class="md-form-group" slot="inputs" style="margin-top: 33px;">
          <md-icon>face</md-icon>
          <label>账号</label>
          <md-input v-model="username"  @keyup.enter="convert_password"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs" :md-toggle-password="false">
          <md-icon>lock_outline</md-icon>
          <label>密码</label>
          <md-input id="passwordInput" @keyup.enter="convert_login"  v-model="password" type="password"></md-input>
        </md-field>
        <div slot="inputs" class="login-code">
          <md-field class="md-form-group" style="width: 63%" @keyup.enter.native="doLogin">
            <md-icon>verified_user</md-icon>
            <label>验证码</label>
            <md-input v-model="answer"></md-input>
          </md-field>
          <div class="login-code-img">
            <img :src="codeUrl" @click="getCode">
          </div>
        </div>
        <md-button slot="footer" @click="doLogin" class="md-simple md-lg md-info " :style="loginBtn">
          开 始
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
  import kayak from '@/frame/kayak.js'
  import auth from "@/utils/auth.js"
  import MD5 from "@/frame/md5.js"
  import LoginCard from "./LoginCard";

  import Notifications from '@/components/k-material/NotificationPlugin'
  import Tools from "../utils/tools";
  export default {
    components: {
      LoginCard
    },
    props: {
      loginConfig: {
        type: Object,
        default: new Object()
      }
    },
    data() {
      return {
        remember: false, // 记住密码
        username: '',
        password: '',
        loading: false,
        showDialog: false,
        t: '',
        codeUrl: '',
        answer: '',
      };
    },
    created() {
      // 获取验证码
      this.getCode()
    },
    methods: {
      doLogin() {
        this.httpUtil.query({
          url: "jwt/login.json",
          params: {
            username: this.username,
            password: MD5.MD5(this.username + this.password),
            t: this.t,
            answer: this.answer
          },
          errCallback: (reData) => {
            Tools.alert(reData.returnmsg || reData.rtnDesc || "操作失败", "danger");
            // 获取验证码
            this.getCode()
          }
        }).then(data => {
          if(data.returndata.lastLoginLog){
            Tools.alert(data.returndata.lastLoginLog);
          }
          auth.setToken(data.returndata.token);
          localStorage.setItem("username", data.returndata.username);
          localStorage.setItem("userid", data.returndata.userid);
          localStorage.setItem("roleids", data.returndata.roleids);
          localStorage.setItem("servers", data.returndata.servers);
          localStorage.setItem("token", data.returndata.token);
          this.$router.push({
            path: '/main'
          });
        });
      },
      convert_password(){
        document.getElementById('passwordInput').focus()
      },
      convert_login(){
        this.doLogin()
      },
      getCode() {
        this.t = new Date().getTime()
        this.httpUtil.verifyCode(this.t).then(data => {
          this.codeUrl = data
        })
      },
    },
    computed: {
      loginBtn() {
        const ret = {};
        ret.color = this.loginConfig.loginColor + "!important";
        return ret;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .login-content i {
    width: 23px !important;
    height: 23px !important;
  }
  .login-code {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .login-code-img {
    width: 33%;
    height: 38px;
    img {
      cursor: pointer;
      vertical-align: middle
    }
  }
  .login-content {
    .md-field.md-field.md-has-value label, .md-field.md-focused label {
      top: -0.8rem;
    }

  }
</style>



// WEBPACK FOOTER //
// src/frame/LoginBox.vue